import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../img/logo.png';
import { FaArrowLeft } from 'react-icons/fa';

function NavBar2({ showBackButton = true }) { // Add a prop with a default value
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Navigate back to the previous page
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full z-50 h-24 mt-8">
      <header className="bg-navbar shadow-xl h-16 flex items-center justify-between px-8">
        {showBackButton ? ( 
          <button onClick={handleBack} className="relative text-black flex items-center">
            <FaArrowLeft />
          </button>
        ):(
          <div></div>
        )}
        <div className="relative rounded-full shadow-xl bg-navbar p-2">
          <a href="/">
            <img src={logo} alt="Logo" className="h-28" />
          </a>
        </div>
        <div className='relative'></div>
      </header>
    </div>
  );
}

export default NavBar2;
